/*eslint-disable*/
import api from '../'

class WordsFieldApi {
    static getGameItems (params) {
        return api.axios.get('corrective-samples-game-items', { params }).then(response => response.data);
    }
}

export default WordsFieldApi;
